import {GALinkStatus} from '../../util/uiconstants';
const checkDisabled = (linkStatusId) => {
	return (
		linkStatusId === GALinkStatus.Accepted ||
		linkStatusId === GALinkStatus.ComponentNotUsingCanvas ||
		linkStatusId === GALinkStatus.Pending ||
		linkStatusId === GALinkStatus.ComponentReferenceOnly ||
		linkStatusId === GALinkStatus.InvalidPointOfContact ||
		linkStatusId === GALinkStatus.Unlinked ||
		linkStatusId === GALinkStatus.NoPointOfContact
	);
};

const normalize = (newjsondata) => {
	var newjsondata2 = newjsondata.map(function(m) {
		if (m.id !== null) {
			var teamList = {
				id: m.gaScopeID,
				type: m.gaScopeTypeID,
				label: m.scopeCustomName,
				selected: false,
				disabled: false,
				isSubScope: m.isSubScope,
				teamList: {
					concurrencyToken: m.concurrencyToken,
					teamId: m.gaComponentID,
					teamName: m.shortName,
					pocgui: m.pocgui,
					pocText: m.pocText,
					linkSentDate: m.linkSentDate,
					linkStatusId: m.gaLinkStatusID,
					instructionStatusId: m.gaInstructionStatusID,
					selected: !checkDisabled(m.gaLinkStatusID),
					disabled: checkDisabled(m.gaLinkStatusID)
				}
			};
		}
		return teamList;
	});
	const data = [];
	let data2 = [];
	newjsondata2.forEach((element) => {
		if (element.id !== null) {
			if (!data.includes(element.id)) {
				data.push(element.id);
				var obj = {
					id: element.id,
					type: element.type,
					label: element.label,
					selected: element.selected,
					disabled: element.disabled,
					isSubScope: element.isSubScope,
					teamList: []
				};
				data2.push(obj);
				newjsondata2
					.filter((m) => m.id === element.id)
					.map((e) => data2[data2.findIndex((x) => x.id === element.id)].teamList.push(e.teamList));
			}
		}
	});
	return data2;
};

export default (teams) => {
	return normalize(teams);
};
